<action-bar>
  <action-button [className]="'action-danger'" [iconClass]="'fa fa-ban'" (actionClick)="onCancel()">Cancel</action-button>
  <action-button [className]="'action-primary'" [iconClass]="'fa fa-floppy-o'" (actionClick)="onSave()" [disabled]="!child || !child.canSave">Save</action-button>
  <action-button [iconClass]="'fa fa-trash'" (actionClick)="updatePositionStatus()">{{activeStatus}}</action-button>
</action-bar>

<edit-position-base [position]="position" [positionLevels]="positionLevels" [positionFunctions]="positionFunctions"
                    [positionDescriptionOverrides]="positionDescriptionOverrides" [userOrgUnits]="userOrgUnits">
</edit-position-base>
